/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiShipmatchCrit.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-shipmatch-crit";

export class AutogenModelEdiShipmatchCrit<RowType extends ModelRow> extends Endpoint<RowType, RowEdiShipmatchCritFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiShipmatchCrit extends ModelRow<RowEdiShipmatchCritFields> {
	constructor(values?: Partial<RowEdiShipmatchCritFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiShipmatchCritFields {
	company_id: string;
	id: string;
	match_type: string;
	max_movement_age: number;
	profile_id: string;
	sequence: number;
}

